import PerformType from "../domain/PerformType";

export const InProgress = new PerformType(-2, 'В процессе')
export const DeliveredOrReturned = new PerformType(-1, 'Доставка или Возврат')
export const Delivered = new PerformType(0, 'Доставлен')
export const ReceiverDead = new PerformType(1, 'Адресат умер')
export const ReceiverNotLivesThere = new PerformType(2, 'Адресат по указанному адресу не проживает')
export const IncompleteAddress = new PerformType(3, 'Указан не полный адрес')
export const ReceiverRefused = new PerformType(4, 'Адресат от получения отказался')
export const ReceiverNotAtHome = new PerformType(5, 'Нет дома')
export const ReceiverDidntAppearOnNotice = new PerformType(6, 'Не явился по извещению')
export const InvalidAddress = new PerformType(7, 'Адрес не определен')
export const TryPerform = new PerformType(8, 'Попытка вручения')
export const OrganizationWithGivenAddressNotFound = new PerformType(9, "По указанному адресу организация не найдена")
